import React, { useEffect } from 'react';
import { TFunction } from 'i18next';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { useCalendar } from './useCalendar';
import { useHtmlValidId } from '../../../../hooks/useHtmlValidId';
import { CalendarSelectData } from './CalendarSelectData';
import { CalendarContent } from './CalendarContent';
import { CalendarEventList } from './CalendarEventList';
import { EventType } from '../../CalendarTypes';

type CalendarType = {
  events: EventType[];
  title: string;
  eventListId: string;
  calendarRangeStart: Date;
  calendarRangeEnd: Date;
};

export function Calendar({ events, title, eventListId, calendarRangeStart, calendarRangeEnd }: CalendarType) {
  const { t } = useSonTranslation('Calendar');
  const tableId = useHtmlValidId();
  const currentMonthId = useHtmlValidId();

  const {
    currentYear,
    currentMonth,
    eventsToShow,
    setEventsToShow,
    setPreviousMonthAndYear,
    setNextMonthAndYear,
    getCalendarDayInfo,
    onClickEvent,
    getClassOfCalendarDay,
    parseSelectedDate,
    weekday,
  } = useCalendar(events, t as TFunction);

  useEffect(() => {
    setEventsToShow([]);
  }, [JSON.stringify(events), setEventsToShow]);

  return (
    <div className="calendar">
      <CalendarSelectData
        currentMonth={currentMonth}
        currentYear={currentYear}
        tableId={tableId}
        currentMonthId={currentMonthId}
        setPreviousMonthAndYear={setPreviousMonthAndYear}
        setNextMonthAndYear={setNextMonthAndYear}
        calendarRangeStart={calendarRangeStart}
        calendarRangeEnd={calendarRangeEnd}
      />
      <CalendarContent
        title={title}
        tableId={tableId}
        eventListId={eventListId}
        eventsToShow={eventsToShow}
        weekday={weekday}
        getCalendarDayInfo={getCalendarDayInfo}
        getClassOfCalendarDay={getClassOfCalendarDay}
        setEventsToShow={setEventsToShow}
        onClickEvent={onClickEvent}
      />
      <CalendarEventList eventListId={eventListId} eventsToShow={eventsToShow} parseSelectedDate={parseSelectedDate} />
    </div>
  );
}
